import React from 'react';
import { withApollo } from 'react-apollo';

import ListView from './ListView';
import { UpdateClaim } from '../../../../../mutations/UpdateClaim';
import { DetachClaimsPassengerTicket } from '../../../../../mutations/DetachClaimsPassengerTicket';

const Passengers = ({
  showLoading,
  hideLoading,
  onClaimUpdated,
  client,
  ...props
}) => {
  const handleContactPersonChange = passengerTicket => {
    if (!passengerTicket || passengerTicket.id === props.passengerTicketId)
      return;
    showLoading();
    client
      .mutate({
        mutation: UpdateClaim,
        variables: {
          input: {
            claim: {
              id: props.id,
              passengerTicketId: passengerTicket.id
            }
          }
        }
      })
      .then(() => {
        hideLoading();
        onClaimUpdated();
      })
      .catch(() => {
        hideLoading();
      });
  };

  const handleRemovePassenger = passengerId => {
    if (!passengerId) return;
    showLoading();
    client
      .mutate({
        mutation: DetachClaimsPassengerTicket,
        variables: {
          input: {
            passengerTicketId: passengerId,
            claimId: props.id
          }
        }
      })
      .then(() => {
        hideLoading();
        onClaimUpdated();
      })
      .catch(() => {
        hideLoading();
      });
  };
  return (
    <ListView
      {...props}
      onContactPersonChange={handleContactPersonChange}
      onRemovePassenger={handleRemovePassenger}
      onClaimUpdated={onClaimUpdated}
    />
  );
};

export default withApollo(Passengers);



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/Passengers/PassengersList/index.js